<template>
</template>
<script>
export default {
  data: function () {
    return {
    }
  },computed: {
  },
  mounted: function() {
    var _this = this;

    if (this.$root.user.apikey == undefined) {
      this.$router.push({path: '/login'});
    }

    $.ajax('https://belepteto.sze.hu/Shibboleth.sso/Logout');

    this.$root.ajax('users/logout/' + this.$root.user.apikey, {
      success: function(response) {
        _this.$root.user = {};
        _this.$root.profilmenu = false;
        _this.$root.searchmenu = false;

        sessionStorage.removeItem("belepteto_apikey");
        sessionStorage.clear();

        _this.$router.push({path: '/login'});
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// logout.vue?244f2d92